import { Outlet } from "react-router-dom";

import { UsersSubNav } from "@/components/ui/admin/users/UsersSubNav";

export function UsersSectionLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col lg:flex-row">
      <div className="hidden lg:flex">
        <UsersSubNav orientation="vertical" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="lg:hidden">
          <UsersSubNav orientation="horizontal" />
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
